import * as React from 'react';

import Avatar from 'components/Avatar';
import { AvatarSize, AvatarColor } from 'components/Avatar';

type Props = {
  color?: AvatarColor,
  size?: AvatarSize,
  className?: string,
};

export default class GroupChatAvatar extends React.PureComponent<Props> {
  render() {
    const { color, size, className } = this.props;

    return <Avatar color={color} size={size} className={className} glyphName="message-group" />;
  }
}
